import React from "react";
import GridItem from "components/Grid/GridItem";
import GridContainer from "components/Grid/GridContainer";
import { FormControlLabel, Checkbox } from "@mui/material";
import { makeStyles } from "@material-ui/core/styles";
import customInputStyle from "assets/jss/material-dashboard-pro-react/components/customInputStyle";
const useStyles = makeStyles(customInputStyle);

export default function SpecialDiscounts({ form, handleChange, buttonsSave }) {
  const classes = useStyles();
  return (
    <GridContainer xs={12} sm={12} md={8}>
      <GridItem xs={12} sm={6}>
        <FormControlLabel
          control={
            <Checkbox
              checked={form.discount_allmexico}
              onChange={handleChange}
              name="discount_allmexico"
              color="primary"
              className={classes.colorCheck}
            />
          }
          label="All of Mexico"
        />
      </GridItem>
      <GridItem xs={12} sm={6}>
        <FormControlLabel
          control={
            <Checkbox
              checked={form.discount_caravan}
              onChange={handleChange}
              name="discount_caravan"
              color="primary"
              className={classes.colorCheck}
            />
          }
          label="Caravan"
        />
      </GridItem>
      <GridItem xs={12} sm={6}>
        <FormControlLabel
          control={
            <Checkbox
              checked={form.discount_combuss}
              onChange={handleChange}
              name="discount_combuss"
              color="primary"
              className={classes.colorCheck}
            />
          }
          label="Commercial/Business"
        />
      </GridItem>
      <GridItem xs={12} sm={6}>
        <FormControlLabel
          control={
            <Checkbox
              checked={form.discount_driverlic}
              onChange={handleChange}
              name="discount_driverlic"
              color="primary"
              className={classes.colorCheck}
            />
          }
          label="Driver license"
        />
      </GridItem>
      <GridItem xs={12} sm={6}>
        <FormControlLabel
          control={
            <Checkbox
              checked={form.discount_resident}
              onChange={handleChange}
              name="discount_resident"
              color="primary"
              className={classes.colorCheck}
            />
          }
          label="Resident"
        />
      </GridItem>
      <GridItem xs={12} sm={6}>
        <FormControlLabel
          control={
            <Checkbox
              checked={form.discount_sobaom}
              onChange={handleChange}
              name="discount_sobaom"
              color="primary"
              className={classes.colorCheck}
            />
          }
          label="Sanborn's Other Borders All of Mexico"
        />
      </GridItem>
      <GridItem xs={12} sm={6}>
        <FormControlLabel
          control={
            <Checkbox
              checked={form.discount_stbaom}
              onChange={handleChange}
              name="discount_stbaom"
              color="primary"
              className={classes.colorCheck}
            />
          }
          label="Sanborn's TX Border All of Mexico"
        />
      </GridItem>
      <GridItem xs={12} sm={6}>
        <FormControlLabel
          control={
            <Checkbox
              checked={form.discount_sentri}
              onChange={handleChange}
              name="discount_sentri"
              color="primary"
              className={classes.colorCheck}
            />
          }
          label="Sentri (Annual Only)"
        />
      </GridItem>
      <GridItem xs={12} sm={6}>
        <FormControlLabel
          control={
            <Checkbox
              checked={form.discount_sanborns_sonora_baja}
              onChange={handleChange}
              name="discount_sanborns_sonora_baja"
              color="primary"
              className={classes.colorCheck}
            />
          }
          label="Sanborn's Sonora & Baja"
        />
      </GridItem>
      <GridItem xs={12} sm={6}>
        <FormControlLabel
          control={
            <Checkbox
              checked={form.discount_sonora_baja}
              onChange={handleChange}
              name="discount_sonora_baja"
              color="primary"
              className={classes.colorCheck}
            />
          }
          label="Sonora & Baja"
        />
      </GridItem>
      <GridItem xs={12} sm={6}>
        <FormControlLabel
          control={
            <Checkbox
              checked={form.discount_arriba}
              onChange={handleChange}
              name="discount_arriba"
              color="primary"
              className={classes.colorCheck}
            />
          }
          label="Arriba Special"
        />
      </GridItem>
      {buttonsSave()}
    </GridContainer>
  );
}
